<template>
  <AppModalEdit
    v-model="isActive"
    :confirm-on-click-cancel="false"
    @clickExec="onClickExec"
    title="ユーザー属性設定"
    exec-button-text="保存"
  >
    <AppForm label="性別">
      <v-radio-group v-model="newSettings.sex" row hide-details>
        <v-radio :value="null" label="全て" />
        <v-radio label="男性" value="male" />
        <v-radio label="女性" value="female" />
      </v-radio-group>
    </AppForm>
    <AppForm label="年代" class="pt-3">
      <v-radio-group v-model="useAge" row hide-details>
        <v-radio :value="false" label="全て" />
        <v-radio :value="true" label="指定する" />
      </v-radio-group>
      <v-slide-y-transition>
        <div v-if="useAge" class="pl-4">
          <v-checkbox
            v-model="newSettings.age"
            label="13 - 17歳"
            value="01"
            hide-details
          />
          <v-checkbox
            v-model="newSettings.age"
            label="18 - 24歳"
            value="02"
            hide-details
          />
          <v-checkbox
            v-model="newSettings.age"
            label="25 - 34歳"
            value="03"
            hide-details
          />
          <v-checkbox
            v-model="newSettings.age"
            label="35 - 44歳"
            value="04"
            hide-details
          />
          <v-checkbox
            v-model="newSettings.age"
            label="45 - 54歳"
            value="05"
            hide-details
          />
          <v-checkbox
            v-model="newSettings.age"
            label="55歳以上"
            value="06"
            hide-details
          />
        </div>
      </v-slide-y-transition>
    </AppForm>
    <AppForm label="婚姻関係" class="pt-3">
      <v-radio-group v-model="newSettings.marriage" row hide-details>
        <v-radio :value="null" label="全て" />
        <v-radio label="既婚" value="married" />
        <v-radio label="未婚" value="single" />
      </v-radio-group>
      <span
        v-if="
          creativeType === CreativeTypes.INFEED && newSettings.marriage !== null
        "
        class="red--text"
      >
        ※
        インフィード広告において婚姻関係をターゲティング条件として指定した場合、配信量が大幅に減少する可能性があります。
      </span>
    </AppForm>
    <AppForm
      v-if="!hidePrefecture && !settings.disabledPrefecture"
      label="居住地"
      class="pt-3"
    >
      <v-radio-group v-model="usePrefecture" row hide-details>
        <v-radio :value="false" label="全て" />
        <v-radio :value="true" label="指定する" />
      </v-radio-group>
      <v-slide-y-transition>
        <AppTwoColumnsSelector
          v-if="usePrefecture"
          :items="prefectureList"
          :value="newSettings.prefecture"
          :is-show-all-select="true"
          @changeChosenItems="onChangePrefecture"
          available-label="居住地一覧"
          chosen-label="配信する居住地一覧"
          item-value="id"
        />
      </v-slide-y-transition>
    </AppForm>
  </AppModalEdit>
</template>

<script>
import { DemographicSettingFormModel } from '@/models/CampaignOperation/Form'
import { initPrefectureModel } from '@/constants/prefecture'
import { CreativeTypes } from '@/models/Creative'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    settings: {
      // DemographicSettingFormModel
      type: Object,
      default: () => {},
    },
    hidePrefecture: {
      type: Boolean,
      default: false,
    },
    creativeType: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      newSettings: new DemographicSettingFormModel(this.settings),
      prefectureList: initPrefectureModel(),
    }
  },
  computed: {
    CreativeTypes() {
      return CreativeTypes
    },
    isActive: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    useAge: {
      get() {
        return this.newSettings.age != null
      },
      set(useAge) {
        if (useAge) {
          this.newSettings.setDefaultAge()
        } else {
          this.newSettings.age = null
        }
      },
    },
    usePrefecture: {
      get() {
        return this.newSettings.prefecture != null
      },
      set(usePrefecture) {
        if (usePrefecture) {
          this.newSettings.setDefaultPrefecture()
        } else {
          this.newSettings.prefecture = null
        }
      },
    },
    ageErrorMessage() {
      return this.useAge && this.newSettings.age.length === 0
        ? '年代が設定されていません。\n配信する年代、または「全て」を設定してください。'
        : ''
    },
    prefectureErrorMessage() {
      return this.usePrefecture && this.newSettings.prefecture.length === 0
        ? '居住地が設定されていません。\n配信する居住地、または「全て」を設定してください。'
        : ''
    },
    errorMessage() {
      return this.ageErrorMessage || this.prefectureErrorMessage
    },
  },
  methods: {
    async onClickExec() {
      const errorMessage = this.errorMessage
      if (errorMessage) {
        await this.$confirm('入力エラー', {
          okText: '閉じる',
          onlyOk: true,
          body: errorMessage,
        })
        return
      }
      this.execChange()
    },
    execChange() {
      this.$emit('change', this.newSettings)
      this.isActive = false
    },
    onChangePrefecture(items) {
      this.newSettings.prefecture = items
    },
  },
}
</script>

<style></style>
